import { render, staticRenderFns } from "./Codeeditor.vue?vue&type=template&id=6037cfd0&"
import script from "./Codeeditor.vue?vue&type=script&lang=js&"
export * from "./Codeeditor.vue?vue&type=script&lang=js&"
import style0 from "./Codeeditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports